"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bomDatasheetCoverageSchema = exports.packageDatasheetGapRowCountsSchema = exports.PackageDatasheetGapReason = exports.DatasheetMissingReason = exports.DatasheetNotApplicableReason = exports.TEST_POINT_SIGMA_MODEL_TYPE = void 0;
exports.resolveDatasheetNotApplicableReason = resolveDatasheetNotApplicableReason;
exports.isDatasheetNotApplicable = isDatasheetNotApplicable;
exports.resolveBomReviewRowDatasheetNotApplicableReason = resolveBomReviewRowDatasheetNotApplicableReason;
exports.resolveBomReviewRowDatasheetMissingReason = resolveBomReviewRowDatasheetMissingReason;
exports.resolvePackageDatasheetGapReason = resolvePackageDatasheetGapReason;
exports.resolveBomReviewRowPackageDatasheetGapReason = resolveBomReviewRowPackageDatasheetGapReason;
exports.summarizeBomDatasheetCoverage = summarizeBomDatasheetCoverage;
const zod_1 = require("zod");
const package_datasheet_state_1 = require("../PackageStore/package-datasheet-state");
const customer_bom_review_grouping_1 = require("./customer-bom-review-grouping");
const mechanical_not_a_part_1 = require("./mechanical-not-a-part");
exports.TEST_POINT_SIGMA_MODEL_TYPE = 'connector.test-point';
var DatasheetNotApplicableReason;
(function (DatasheetNotApplicableReason) {
    DatasheetNotApplicableReason["Dnp"] = "dnp";
    DatasheetNotApplicableReason["NotAPart"] = "not_a_part";
})(DatasheetNotApplicableReason || (exports.DatasheetNotApplicableReason = DatasheetNotApplicableReason = {}));
var DatasheetMissingReason;
(function (DatasheetMissingReason) {
    DatasheetMissingReason["PackageWithoutDatasheet"] = "package_without_datasheet";
    DatasheetMissingReason["PartNotIdentified"] = "part_not_identified";
})(DatasheetMissingReason || (exports.DatasheetMissingReason = DatasheetMissingReason = {}));
var PackageDatasheetGapReason;
(function (PackageDatasheetGapReason) {
    PackageDatasheetGapReason["StillSearching"] = "still_searching";
    PackageDatasheetGapReason["NothingFound"] = "nothing_found";
    PackageDatasheetGapReason["AllCandidatesRejected"] = "all_candidates_rejected";
    PackageDatasheetGapReason["NoSources"] = "no_sources";
    PackageDatasheetGapReason["NotAssessed"] = "not_assessed";
    PackageDatasheetGapReason["Other"] = "other";
})(PackageDatasheetGapReason || (exports.PackageDatasheetGapReason = PackageDatasheetGapReason = {}));
const rowCountSchema = zod_1.z.number().int().nonnegative();
exports.packageDatasheetGapRowCountsSchema = zod_1.z.object({
    [PackageDatasheetGapReason.StillSearching]: rowCountSchema,
    [PackageDatasheetGapReason.NothingFound]: rowCountSchema,
    [PackageDatasheetGapReason.AllCandidatesRejected]: rowCountSchema,
    [PackageDatasheetGapReason.NoSources]: rowCountSchema,
    [PackageDatasheetGapReason.NotAssessed]: rowCountSchema,
    [PackageDatasheetGapReason.Other]: rowCountSchema,
});
exports.bomDatasheetCoverageSchema = zod_1.z.object({
    expectedRowCount: rowCountSchema,
    coveredRowCount: rowCountSchema,
    missingPackageRowCount: rowCountSchema,
    missingPackageRowCountsByReason: exports.packageDatasheetGapRowCountsSchema.optional(),
    missingUnidentifiedRowCount: rowCountSchema,
    dnpRowCount: rowCountSchema,
    notAPartRowCount: rowCountSchema,
});
function resolveDatasheetNotApplicableReason(flags) {
    if (flags.isVirtual ||
        flags.isNonElectrical ||
        flags.sigmaModelType === exports.TEST_POINT_SIGMA_MODEL_TYPE ||
        (0, mechanical_not_a_part_1.isMechanicalNotAPart)(flags.staticMetadata, () => flags.manufacturerPartNumber === null ?
            flags.metadataPartNumbers
            : [flags.manufacturerPartNumber, ...flags.metadataPartNumbers])) {
        return DatasheetNotApplicableReason.NotAPart;
    }
    if (flags.isDnp) {
        return DatasheetNotApplicableReason.Dnp;
    }
    return null;
}
function isDatasheetNotApplicable(flags) {
    return resolveDatasheetNotApplicableReason(flags) !== null;
}
function resolveBomReviewRowDatasheetNotApplicableReason(group) {
    const reasons = group.map((item) => resolveDatasheetNotApplicableReason(item));
    if (reasons.length === 0 || reasons.includes(null)) {
        return null;
    }
    return reasons.includes(DatasheetNotApplicableReason.NotAPart) ?
        DatasheetNotApplicableReason.NotAPart
        : DatasheetNotApplicableReason.Dnp;
}
function resolveBomReviewRowDatasheetMissingReason(group) {
    if (!(0, customer_bom_review_grouping_1.isBomReviewRowWithoutDatasheet)({ datasheetFileId: (0, customer_bom_review_grouping_1.resolveBomReviewDatasheetFileId)(group) })) {
        return null;
    }
    return group.some((item) => item.packageId !== null) ?
        DatasheetMissingReason.PackageWithoutDatasheet
        : DatasheetMissingReason.PartNotIdentified;
}
function resolvePackageDatasheetGapReason(state, reason) {
    if (state === null) {
        return PackageDatasheetGapReason.NotAssessed;
    }
    if (state === package_datasheet_state_1.DatasheetState.Searching) {
        return PackageDatasheetGapReason.StillSearching;
    }
    if (state !== package_datasheet_state_1.DatasheetState.NotFound) {
        return PackageDatasheetGapReason.Other;
    }
    switch (reason) {
        case package_datasheet_state_1.DatasheetStateReason.AllSourcesFailed:
        case package_datasheet_state_1.DatasheetStateReason.AgentNotFound:
            return PackageDatasheetGapReason.NothingFound;
        case package_datasheet_state_1.DatasheetStateReason.AllCandidatesRejected:
            return PackageDatasheetGapReason.AllCandidatesRejected;
        case package_datasheet_state_1.DatasheetStateReason.NoSources:
            return PackageDatasheetGapReason.NoSources;
        default:
            return PackageDatasheetGapReason.Other;
    }
}
function resolveBomReviewRowPackageDatasheetGapReason(group) {
    const bound = group.find((item) => item.packageId !== null);
    if (bound === undefined) {
        return null;
    }
    return resolvePackageDatasheetGapReason(bound.packageDatasheetState, bound.packageDatasheetStateReason);
}
function summarizeBomDatasheetCoverage(items) {
    const byReason = {
        [PackageDatasheetGapReason.StillSearching]: 0,
        [PackageDatasheetGapReason.NothingFound]: 0,
        [PackageDatasheetGapReason.AllCandidatesRejected]: 0,
        [PackageDatasheetGapReason.NoSources]: 0,
        [PackageDatasheetGapReason.NotAssessed]: 0,
        [PackageDatasheetGapReason.Other]: 0,
    };
    const coverage = {
        expectedRowCount: 0,
        coveredRowCount: 0,
        missingPackageRowCount: 0,
        missingPackageRowCountsByReason: byReason,
        missingUnidentifiedRowCount: 0,
        dnpRowCount: 0,
        notAPartRowCount: 0,
    };
    const rows = [
        ...(0, customer_bom_review_grouping_1.groupBomReviewItems)(items.filter((item) => !item.isVirtual)).values(),
        ...(0, customer_bom_review_grouping_1.groupBomReviewItems)(items.filter((item) => item.isVirtual)).values(),
    ];
    for (const row of rows) {
        const notApplicableReason = resolveBomReviewRowDatasheetNotApplicableReason(row);
        if (notApplicableReason === DatasheetNotApplicableReason.Dnp) {
            coverage.dnpRowCount += 1;
            continue;
        }
        if (notApplicableReason === DatasheetNotApplicableReason.NotAPart) {
            coverage.notAPartRowCount += 1;
            continue;
        }
        coverage.expectedRowCount += 1;
        const missingReason = resolveBomReviewRowDatasheetMissingReason(row);
        if (missingReason === null) {
            coverage.coveredRowCount += 1;
        }
        else if (missingReason === DatasheetMissingReason.PackageWithoutDatasheet) {
            coverage.missingPackageRowCount += 1;
            byReason[resolveBomReviewRowPackageDatasheetGapReason(row) ?? PackageDatasheetGapReason.Other] += 1;
        }
        else {
            coverage.missingUnidentifiedRowCount += 1;
        }
    }
    return coverage;
}
//# sourceMappingURL=bom-datasheet-coverage.js.map